import { Component, ViewChild, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Router, RouterLink } from "@angular/router";

import { ActionButtonComponent } from "../shared/action-button/action-button.component";
import { ApiService } from "src/app/api.service";
declare const BrandVars;

@Component({
	selector: "app-login",
	templateUrl: "./login.component.html",
	styleUrls: ["./login.component.scss"],
	imports: [FormsModule, ActionButtonComponent, RouterLink]
})
export class LoginComponent {
	router = inject(Router);
	private api = inject(ApiService);

	@ViewChild("loginButton") loginButton: ActionButtonComponent;

	public brand = BrandVars;
	email = "";
	password = "";
	mfaCode = "";
	showMfa = false;

	async Login() {
		try {
			await this.api.Login(this.email, this.password, this.showMfa ? this.mfaCode : undefined, true);
			this.router.navigate(["dash"]);
		} catch (err) {
			if (err?.status === 401) {
				if (err.error?.message === "MFA code is required") {
					this.showMfa = true;
					setTimeout(() => {
						document.getElementById("mfa").focus();
					}, 100);
				} else if (err.error?.message === "All admins must have MFA enabled to log in") {
					throw new Error("Admins must have MFA enabled to log in", { cause: err });
				} else {
					if (this.showMfa) {
						throw new Error("Invalid MFA code", { cause: err });
					} else {
						throw new Error("Invalid username or password", { cause: err });
					}
				}
			} else if (err?.status === 429) {
				throw new Error("Too many login attempts. Please wait 15 minutes and try again.", { cause: err });
			} else {
				throw new Error("Login failed", { cause: err });
			}
		}
	}

	CancelMfa() {
		this.mfaCode = "";
		this.showMfa = false;
		this.loginButton.problem = undefined;
	}
}
